// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_6p-4";
export var collapsed = "_6p-1";
export var headerBar = "_6p-0";
export var leftHeaderContent = "_6p-3";
export var subjectContainer = "_6p-2";